import React, { useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Html, OrbitControls } from "@react-three/drei";

function Sample({ inserted }) {
  const [y, setY] = useState(2);

  useFrame(() => {
    if (inserted && y > 0.5) setY((prev) => prev - 0.05); // descend doucement
  });

  if (!inserted) return null;
  return (
    <mesh position={[0, y, 1.5]}>
      <cylinderGeometry args={[0.2, 0.2, 0.6, 16]} />
      <meshStandardMaterial color="red" />
      <Html position={[0, 0.5, 0]} center>
        <div style={{ fontWeight: "bold", color: "#fff" }}>Échantillon</div>
      </Html>
    </mesh>
  );
}

export default function Demo3DPage() {
  const [sampleInserted, setSampleInserted] = useState(false);
  const [result, setResult] = useState(null);

  const handleInsertSample = () => {
    if (sampleInserted) return;
    setSampleInserted(true);
    setResult("Analyse en cours...");
    setTimeout(() => {
      setResult("Résultat : Parasitémie 2%");
    }, 5000);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h1>Démo Machine MalariaScan AI</h1>
      <p>Insérez un échantillon pour voir le résultat</p>

      <Canvas
        camera={{ position: [6, 4, 8], fov: 50 }}
        style={{ height: "400px" }}
      >
        <ambientLight intensity={0.7} />
        <directionalLight position={[5, 5, 5]} intensity={1} />
        <OrbitControls enableZoom={true} enablePan={true} />

        {/* Corps de la machine */}
        <mesh position={[0, 0, 0]}>
          <boxGeometry args={[4, 3, 4]} />
          <meshStandardMaterial color="#777" />
        </mesh>

        {/* Écran */}
        <mesh position={[0, 1.2, 2.1]}>
          <boxGeometry args={[2, 1, 0.1]} />
          <meshStandardMaterial color="#1e90ff" />
          <Html position={[0, 0, 0.1]} center>
            <div style={{ color: "#fff", fontWeight: "bold" }}>Écran</div>
          </Html>
        </mesh>

        {/* Fente d'insertion */}
        <mesh position={[0, -0.5, 2.1]}>
          <boxGeometry args={[1, 0.3, 0.2]} />
          <meshStandardMaterial color="#333" />
        </mesh>

        {/* Échantillon animé */}
        <Sample inserted={sampleInserted} />
      </Canvas>

      <div style={{ marginTop: "1rem" }}>
        <button onClick={handleInsertSample} disabled={sampleInserted}>
          {sampleInserted ? "Échantillon inséré" : "Insérer échantillon"}
        </button>
      </div>

      {result && (
        <p style={{ marginTop: "1rem", fontWeight: "bold" }}>{result}</p>
      )}
    </div>
  );
}
